import {
  ICheckoutRules,
  CheckoutRulesKeys,
} from '../graphQL/queries/getSession/types'
import { Localization } from '../interfaces'

export const getMesageOnCheckoutRules = (
  checkoutRuleMessage: string,
  localization: Localization,
): string => {
  try {
    const parsed = JSON.parse(checkoutRuleMessage)
    return parsed[localization] || ''
  } catch {
    return checkoutRuleMessage
  }
}

export const castCheckoutRulesMessages = (
  checkoutRules: ICheckoutRules,
  language: Localization,
): ICheckoutRules => {
  let castedCheckoutRules = { ...checkoutRules }
  const checkoutRulesKeys = Object.keys(
    checkoutRules,
  ) as (keyof ICheckoutRules)[]
  checkoutRulesKeys.forEach((key: CheckoutRulesKeys) => {
    if (castedCheckoutRules[key]?.message) {
      const currentRule: ICheckoutRules[keyof ICheckoutRules] = {
        ...castedCheckoutRules[key],
        message: getMesageOnCheckoutRules(
          castedCheckoutRules[key].message,
          language,
        ),
      }
      castedCheckoutRules = {
        ...castedCheckoutRules,
        [key]: currentRule,
      }
    }
  })
  return castedCheckoutRules
}
